import React from 'react';

import { WebCopy, Input } from 'components';

interface PasswordInputProps {
  className: any;
  passwordLabel: any;
  password: any;
  errors: any;
  handlePasswordChanged: any;
}
export const PasswordInput: React.FC<PasswordInputProps> = ({
  className,
  passwordLabel,
  password,
  errors,
  handlePasswordChanged,
}) => {
  return (
    <>
      <Input
        className={className}
        error={!!errors.password}
        fullWidth
        type={'password'}
        label={passwordLabel}
        value={password}
        onChange={handlePasswordChanged}
      />
      {!!errors.password ? <WebCopy type="Error">{errors.password}</WebCopy> : null}
    </>
  );
};
